// extracted by mini-css-extract-plugin
module.exports = {"pagination":"_2Ey8-","prev":"_35xRX","next":"WtQOd"};